<template lang="pug">
v-layout(row, wrap)
  v-flex.md12.xs12.text-xs-center
    v-card.cardPadrao.px-3.Poppins(style="border-radius: 10px;", color="white")
      v-card-actions
        v-layout(row, wrap).pt-3
          v-flex.md3.xs3.text-xs-center
            .body-1.font-weight-bold
              span Total Bruto
              v-icon(@click="openDiagloInfoTotalBruto()").clicable.pl-2 info
            .headline.font-weight-bold {{ indicadores.total_bruto | currency }}
          v-flex.md3.xs3.text-xs-center
            .body-1
              span Pedidos de Novos Clientes
            .headline {{ indicadores.total_novos | currency }}
            .caption(v-if="indicadores.quantidade_novos") ({{ indicadores.quantidade_novos | number}} pedidos)
          v-flex.md3.xs3.text-xs-center
            .body-1 Cupons da Loja
            .headline {{ indicadores.desconto_estabelecimento | currency }}
            .caption(v-if="indicadores.quantidade_desconto_estabelecimento") ({{ indicadores.quantidade_desconto_estabelecimento | number}} pedidos)
          v-flex.md3.xs3.text-xs-center
            .body-1
              span Pedidos Cancelados
              v-icon(@click="openDiagloInfoCancelados()").clicable.pl-2 info
            .headline {{ indicadores.total_cancelados | currency }}
            .caption(v-if="indicadores.quantidade_cancelados") ({{ indicadores.quantidade_cancelados | number}} pedidos)
          v-flex.md3.xs3.text-xs-center.pt-3
            .body-1 Taxas de Entrega
            .headline {{ indicadores.total_taxa_entrega | currency }}
            .caption(v-if="indicadores.quantidade_taxa_entrega") ({{ indicadores.quantidade_taxa_entrega | number}} pedidos)

</template>

<script>

export default {
  props: {
    indicadores: {
      type: Object,
      default: {}
    },
  },
  data () {
    return {
      expanded: false,
    }
  },
  created () {
  },
  watch: {
  },
  computed: {
  },
  methods: {
    openDiagloInfoTotalBruto(){
      this.$emit("info-total-bruto");
    },
    openDiagloInfoCancelados(){
      this.$emit("info-cancelados");
    }
  }
}
</script>
